import React from 'react';

const PagePrivacy = () => {
      return (
          <div className="TCWrapper" style={{ marginBottom: "5rem"}}>
          <div>
            <div>
                <div>
                  <h1>Privacy Policy</h1>
                  <p>Updated at 2026-08-23</p>
                  <br/>
                  <p className="p8"><span className="s1">
                    This Privacy Policy explains how mattool.in (“mattool.in”, “we”, “us”, or “our”) handles information for the mattool.in website and the Where Is My Bus mobile app.
                  </span></p>
                  <p className="p9"><br/></p>

                  <h1>Where Is My Bus (mobile app)</h1>
                  <p className="p10"><span className="s1">
                    Where Is My Bus shows local bus schedules. It does not require an account and does not ask for location, camera, or microphone access.
                    <br/><br/>
                    We do not collect, store, or share personal information through this app. Schedule data is stored on the device so you can check timings even with a weak network.
                    <br/><br/>
                    If a future version starts collecting data, we will update this policy before that change.
                  </span></p>
                  <p className="p9"><br/></p>

                  <h1>mattool.in website</h1>
                  <p className="p10"><span className="s1">
                    If you use mattool.in in a browser, we may process information you choose to provide, such as an account, phone number, or messages you post, so we can run the site and its services. We also use cookies and similar technologies as described in our Terms &amp; Conditions.
                    <br/><br/>
                    We do not sell your personal information.
                  </span></p>
                  <p className="p9"><br/></p>

                  <h1>Contact Us</h1>
                  <p className="p10"><span className="s1">Questions about this policy can be sent to us here:</span></p>
                  <ul className="ul1">
                      <li className="li16"><span className="s3">Via Email: <a href="mailto:contact.mattool.live@gmail.com">contact.mattool.live@gmail.com</a></span></li>
                      <li className="li16"><span className="s3">Via this Link: <a href="https://mattool.in">https://mattool.in</a></span></li>
                      <li className="li16"><span className="s3">Terms &amp; Conditions: <a href="https://mattool.in?page=tc">https://mattool.in?page=tc</a></span></li>
                      <li className="li16"><span className="s3">Support: <a href="https://mattool.in?page=support">https://mattool.in?page=support</a></span></li>
                  </ul>
                </div>
            </div>
          </div>
          </div>
        )
}

export default PagePrivacy
